import _extends from "@babel/runtime/helpers/esm/extends";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import cn from 'classnames';
import { sharedInputButtonTypes } from '../utils/proptypes';
function InputButton(_ref) {
  var className = _ref.className,
    disabled = _ref.disabled,
    Icon = _ref.icon,
    id = _ref.id,
    label = _ref.label,
    mainIcon = _ref.mainIcon,
    reversed = _ref.reversed,
    subText = _ref.subText,
    props = _objectWithoutProperties(_ref, ["className", "disabled", "icon", "id", "label", "mainIcon", "reversed", "subText"]);
  return jsx("div", {
    sx: styles.container,
    className: cn('zenit', className)
  }, jsx("label", {
    sx: _objectSpread(_objectSpread(_objectSpread({}, styles.label), disabled && styles.label.disabled), reversed && styles.label.reversed),
    htmlFor: id
  }, jsx("span", {
    sx: _objectSpread(_objectSpread({}, styles.mainIconWrapper), reversed && styles.mainIconWrapper.reversed)
  }, mainIcon), jsx("input", _extends({
    sx: styles.input
  }, props, {
    disabled: disabled,
    id: id
  })), jsx("div", {
    sx: styles.mainContent
  }, reversed && Icon && jsx(Icon, null), jsx("div", {
    sx: styles.texts
  }, jsx("div", null, label), subText && jsx("div", {
    sx: styles.subText
  }, subText)))));
}
var styles = {
  container: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    marginBottom: 2,
    '&:last-child': {
      marginBottom: 0
    }
  },
  label: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    cursor: 'pointer',
    color: 'grey.10',
    fontSize: 1,
    lineHeight: 1,
    disabled: {
      cursor: 'default',
      color: 'grey.7'
    },
    reversed: {
      justifyContent: 'space-between'
    }
  },
  mainContent: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    // Note: this overflow is needed to make ellipsis work: https://css-tricks.com/flexbox-truncated-text/
    overflow: 'hidden',
    '> *': {
      flexShrink: 0,
      marginRight: 2,
      '&:last-child': {
        marginRight: 0
      }
    }
  },
  texts: {
    maxWidth: '100%',
    // Note: this overflow is needed to make ellipsis work
    overflow: 'hidden',
    flexShrink: 1,
    '> *': {
      maxWidth: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'noWrap'
    }
  },
  subText: {
    fontSize: 0,
    lineHeight: 0,
    fontWeight: 'light'
  },
  mainIconWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 2,
    reversed: {
      order: 2,
      marginRight: 0,
      marginLeft: 2
    }
  },
  input: {
    display: 'none'
  }
};
InputButton.TYPES = {
  checkbox: 'checkbox',
  radio: 'radio'
};
InputButton.defaultProps = {
  reversed: false
};
export { InputButton };